import React from "react";

import * as encadreStyles from "../../../styles/admissions/admissions.module.scss";

const Encadre = ({ children, ...props }) => {
  let color = props.color === "primary" ? "var(--red-color)" : "var(--darker-white-color)";
  return (
    <div
      className={encadreStyles.encadre}
      style={{border: `1px solid ${color}` }}
    >
      {children}
    </div>
  );
};

export default Encadre;
